export const API_URL =
  // eslint-disable-next-line eqeqeq
  window.location.hostname == "localhost"
    ? "http://localhost:5001/bohouse-1/us-central1/app/"
    : "https://us-central1-bohouse-1.cloudfunctions.net/app/";
    

    export const API_URL_NEW =
  // eslint-disable-next-line eqeqeq
  window.location.hostname == "localhost"
    ? "http://localhost:5001/bohouse-1/us-central1/"
    : "https://us-central1-bohouse-1.cloudfunctions.net/";
    